import React, { useState, useEffect } from "react";
import { Select, Label, ErrorMessage, LabelWithContainer } from "./FormStyles";
import Spinner from "../Common/Spinner";
import useEmpresa from "../../hooks/useEmpresa";
import CheckRender from "../Common/CheckRender";
import { validationSchemaRequired } from "../../utils/SchemaValidations";
import { isEmptyValue } from "../../utils/StringUtil";

const CustomSelect = ({
  options,
  label,
  value,
  showDefaultOption,
  onChange,
  width,
  height,
  minWidth,
  disabled,
  required,
  dataLoading,
  showRequired,
  labelColor,
  labelWeight,
  isLabelWithContainer,
  labelWidth,
  labelHeight
}) => {
  const empresa = useEmpresa();

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (required && showRequired && isEmptyValue(value)) {
      requireField();
    }
  }, [showRequired]); // eslint-disable-line react-hooks/exhaustive-deps

  const validate = async (valueField) => {
    try {
      if (required) {
        await validationSchemaRequired.validate({
          requiredField: valueField
        });
      }
      setErrors({});
    } catch (error) {
      setErrors({ [error.path]: error.message });
    }
  };

  const requireField = async () => {
    try {
      await validationSchemaRequired.validate({
        requiredField: null
      });
      setErrors({});
    } catch (error) {
      setErrors({ [error.path]: error.message });
    }
  };

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
    validate(selectedValue);
  };

  return (
    <>
      <CheckRender allowed={label}>
        <CheckRender allowed={isLabelWithContainer}>
          <div>
            <LabelWithContainer
              font={empresa?.LETRA_PRINCIPAL}
              labelWidth={labelWidth}
              labelHeight={labelHeight}
              labelColor={labelColor}
              labelWeight={labelWeight}
            >
              {label}
            </LabelWithContainer>
          </div>
        </CheckRender>
        <CheckRender allowed={!isLabelWithContainer}>
          <Label
            weight={labelWeight}
            color={labelColor}
            font={empresa?.LETRA_PRINCIPAL}
          >
            {label}
          </Label>
        </CheckRender>
      </CheckRender>

      <CheckRender allowed={dataLoading}>
        <Spinner size={20} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
      </CheckRender>

      <CheckRender allowed={!dataLoading}>
        <Select
          value={value || ""}
          onChange={handleChange}
          font={empresa?.LETRA_PRINCIPAL}
          width={width}
          minWidth={minWidth}
          height={height}
          disabled={disabled}
        >
          {showDefaultOption && (
            <option key={0} value={""} disabled={true}>
              {"Seleccionar"}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </CheckRender>
      {errors.requiredField && (
        <ErrorMessage>{errors.requiredField}</ErrorMessage>
      )}
    </>
  );
};

export default CustomSelect;
